<template>
  <button
    class="px-4 py-2 sm:px-8 sm:py-3.5 rounded-md transition-all duration-200 bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary-dark hover:shadow-lg focus:bg-white focus:text-primary-dark focus:ring-2 focus:outline-none focus:ring-offset-2 focus:ring-primary-dark"
  >
    <slot />
  </button>
</template>
